import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import React from 'react';

import { useChargePointContext } from '@app/feature/charge-point/charge-point.context';
import { useCpmsBoGetOverviewStatisticsQuery } from '@service/cpms-bo-transaction-reports-overview-statistics.service';

import * as css from 'src/feature/charge-point/charge-point-details/charge-point-details.module.scss';

import { InformationCardComponent } from './cards/information-card.component';
import { LocalizationCardComponent } from './cards/localization-card.component';
import {
  StatisticsCard,
  StatisticsCardVariantEnum,
} from './cards/statistics.card';
import { TariffCardComponent } from './cards/tariff-card.component';

export const InformationTabComponent = (): React.JSX.Element => {
  const { id: chargePointId } = useChargePointContext();
  const { data } = useCpmsBoGetOverviewStatisticsQuery({ chargePointId });

  return (
    <Stack className={css.informationTab} direction="column" gap={GapEnum.L}>
      <Stack direction="row" gap={GapEnum.L}>
        <StatisticsCard
          variant={StatisticsCardVariantEnum.Transactions}
          data={data?.count}
        />
        <StatisticsCard
          variant={StatisticsCardVariantEnum.Energy}
          data={data?.energy}
        />
        <StatisticsCard
          variant={StatisticsCardVariantEnum.Revenue}
          data={data?.revenue}
        />
      </Stack>
      <Stack direction="row" flex={1} gap={GapEnum.L}>
        <Stack direction="column" gap={GapEnum.L} flex={1}>
          <InformationCardComponent />
          <TariffCardComponent />
        </Stack>
        <Stack direction="column" gap={GapEnum.L} flex={1}>
          <LocalizationCardComponent />
        </Stack>
      </Stack>
    </Stack>
  );
};
